/*
 *
 * Users actions
 *
 */

import {
  FLUSH_STATE,
  LOAD_USERS,
  LOAD_USERS_SUCCESS,
  LOAD_USERS_ERROR,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
} from './constants';

export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}

/**
 * Load the users, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_USERS
 */
export function loadUsers() {
  return {
    type: LOAD_USERS,
  };
}

/**
 * Dispatched when the loadUsers are loaded by the request saga
 *
 * @param  {array} variables true for users
 *
 * @return {object}      An action object with a type of LOAD_USERS_SUCCESS passing the variables
 */
export function loadUsersSuccess(usersList, firstElem) {
  return {
    type: LOAD_USERS_SUCCESS,
    usersList,
    firstElem
  };
}

/**
 * Dispatched when loading the loadUsers fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_USERS_ERROR passing the error
 */
export function loadUsersError(error) {
  return {
    type: LOAD_USERS_ERROR,
    error,
  };
}

// Update for Single User
export function updateUser(userDetail, actionType = 'update') {
  return {
    type: UPDATE_USER,
    userDetail,
    actionType
  };
}
export function updateUserSuccess(userDetail) {
  return {
    type: UPDATE_USER_SUCCESS,
    userDetail,
  };
}

export function updateUserError(error) {
  return {
    type: UPDATE_USER_ERROR,
    error,
  };
}